// Global state to track which component is active
let activeComponent = null;

const openFilterDrawer = () => {
  const filterDrawer = document.querySelector(".filters-drawer");
  if (!filterDrawer) return;

  filterDrawer.classList.add("open");
  document.body.style.overflow = "hidden";
  mainOverlay.classList.add("active");
  mainOverlay.addEventListener("click", closeFilterDrawer);
  activeComponent = "filter";
};

const closeFilterDrawer = () => {
  const filterDrawer = document.querySelector(".filters-drawer");
  if (!filterDrawer) return;

  filterDrawer.classList.remove("open");
  document.body.style.overflow = "";
  mainOverlay.classList.remove("active");

  mainOverlay.removeEventListener("click", closeFilterDrawer);
  activeComponent = null;
};

document.addEventListener("DOMContentLoaded", () => {
  const header = document.getElementById("main-header");
  // Mobile menu functionality
  const mobileMenuBtn = document.getElementById("mobile-menu-btn");
  const mobileMenuDropdown = document.getElementById("mobile-menu-dropdown");
  const mobileMenuClose = document.querySelector(".close_mobile_menu");

  // Mobile search functionality
  const searchBtn = document.getElementById("search-btn");
  const searchForm = document.getElementById("header__search");
  const searchInput = searchForm?.querySelector(".header__search-input");

  // Cart Drawer
  const cartDrawer = document.getElementById("cart-drawer");

  // Controlling Main overlay
  const mainOverlay = document.querySelector(".main__overlay");

  // Open/Close Menu
  const toggleMenu = () => {
    const isOpening = !mobileMenuBtn.classList.contains("active");

    let timeoutId;

    if (isOpening && !isFixed) {
      timeoutId = setTimeout(() => {
        defaultHeader();
      }, 16);
    } else {
      clearTimeout(timeoutId);
      if (isTransparentEnabled) {
        initializeHeader(window.scrollY);
      }
    }

    mobileMenuBtn.classList.toggle("active");
    mobileMenuDropdown.classList.toggle("active");

    if (isOpening) {
      lockHeaderVisibility();

      if (activeComponent === "search") closeSearch();
      if (activeComponent === "cart") closeCartDrawer();

      // Add overlay click handler when opening
      mainOverlay.addEventListener("click", toggleMenu);

      // Set active component
      activeComponent = "menu";
    } else {
      unlockHeaderVisibility();
      const subMenu = document.querySelector(".mobile-hidden-menu.show");
      if (subMenu) {
        subMenu.classList.remove("show");
      }

      // Remove overlay click handler when closing
      mainOverlay.removeEventListener("click", toggleMenu);

      activeComponent = null;
    }

    if (mainOverlay.classList.contains("active")) {
      mainOverlay.classList.remove("active");
    } else {
      mainOverlay.classList.add("active");
    }

    document.body.style.overflow = mobileMenuBtn.classList.contains("active")
      ? "hidden"
      : "";
  };

  mobileMenuClose.addEventListener("click", toggleMenu);

  // Keep track of overlay click handler
  let overlayClickHandler = null;

  const showSearch = () => {
    lockHeaderVisibility();

    if (activeComponent === "cart") closeCartDrawer();
    if (activeComponent === "menu") toggleMenu();

    // Prepare search UI
    searchForm.style.transition = "all 0.3s ease";

    if (document.body.overflow != "hidden") {
      document.body.style.overflow = "hidden";
    }

    // Handle header events if not fixed
    if (!isFixed) {
      removeHeaderEvents();
    }

    // Use requestAnimationFrame for smoother animation
    requestAnimationFrame(() => {
      searchForm.classList.add("active");
      mainOverlay.classList.add("active");
      searchInput.focus();
      adjustOverlay();
      activeComponent = "search";

      // Set header state if not fixed
      if (!isFixed && isTransparentEnabled) {
        defaultHeader();
      }

      // Add overlay click handler only once
      if (!overlayClickHandler) {
        overlayClickHandler = (e) => {
          // Only close if clicking directly on overlay (not children)
          if (e.target === mainOverlay) {
            closeSearch(false);
          }
        };
        mainOverlay.addEventListener("click", overlayClickHandler);
      }
    });
  };

  const closeSearch = (mouseInHeader = false) => {
    // Reset search UI
    searchForm.style.transition = "none";
    searchForm.classList.remove("active");
    mainOverlay.classList.remove("active");
    searchInput.value = "";
    resetOverlay();
    document.body.style.overflow = "";
    activeComponent = null;

    // Remove overlay click handler
    if (overlayClickHandler) {
      mainOverlay.removeEventListener("click", overlayClickHandler);
      overlayClickHandler = null;
    }

    // Restore header state if not fixed
    if (!isFixed && isTransparentEnabled) {
      initializeHeaderEvents();
      mouseInHeader ? defaultHeader() : initializeHeader(window.scrollY);
    }
  };

  // Initialize Menu Drawer event listeners
  if (mobileMenuBtn && mobileMenuDropdown) {
    mobileMenuBtn.addEventListener("click", toggleMenu);
  }

  // Initialize Search Drawer event listeners
  if (searchBtn && searchForm) {
    searchBtn.addEventListener("click", showSearch);
  }

  let timeoutCart;
  //Open Cart Drawer
  const openCartDrawer = () => {
    if (cartDrawer.classList.contains("open")) return;
    cartDrawer.classList.add("open");
    mainOverlay.classList.add("active");

    if (activeComponent === "search") closeSearch();
    if (activeComponent === "menu") toggleMenu();

    activeComponent = "cart";

    if (document.body.overflow != "hidden") {
      document.body.style.overflow = "hidden";
    }

    lockHeaderVisibility();

    // Set header state if not fixed
    if (!isFixed && isTransparentEnabled) {
      timeoutCart = setTimeout(() => {
        defaultHeader();
      }, 16);
    }

    // Add overlay click handler only once
    if (!overlayClickHandler) {
      overlayClickHandler = (e) => {
        if (e.target === mainOverlay) {
          closeCartDrawer();
        }
      };
      mainOverlay.addEventListener("click", overlayClickHandler);
    }
  };

  //Close Cart Drawer
  const closeCartDrawer = () => {
    cartDrawer.classList.remove("open");
    mainOverlay.classList.remove("active");
    document.body.style.overflow = "";
    activeComponent = null;

    if (isTransparentEnabled) {
      initializeHeader(window.scrollY);
      clearTimeout(timeoutCart);
    }

    // Remove overlay click handler
    if (overlayClickHandler) {
      mainOverlay.removeEventListener("click", overlayClickHandler);
      overlayClickHandler = null;
    }

    unlockHeaderVisibility();
  };

  // Close search when clicking outside (header/announcement)
  document.addEventListener("mousedown", (e) => {
    if (activeComponent !== "search") return;

    const searchElements = [
      document.querySelector(".header__search-container"),
      document.getElementById("search-btn"),
    ];

    const clickedInsideSearch = searchElements.some(
      (el) => el && (el === e.target || el.contains(e.target))
    );

    if (!clickedInsideSearch) {
      closeSearch(header.contains(e.target));
    }
  });

  // Track mouse position globally
  let lastMouseX = 0;
  let lastMouseY = 0;

  document.addEventListener(
    "mousemove",
    throttle((e) => {
      lastMouseX = e.clientX;
      lastMouseY = e.clientY;
    }, 16)
  );

  // Modified escape key handler
  const handleEscapeKey = (e) => {
    if (e.key === "Escape") {
      if (activeComponent === "menu") {
        toggleMenu();
      } else if (activeComponent === "search") {
        // Get element under current mouse position
        const hoveredElement = document.elementFromPoint(
          lastMouseX,
          lastMouseY
        );
        const isMouseOverHeaderNow = header.contains(hoveredElement);

        closeSearch(isMouseOverHeaderNow);
      } else if (activeComponent === "cart") {
        closeCartDrawer();
      } else if (activeComponent === "filter") {
        closeFilterDrawer();
      }
      // else if (activeComponent === "video-popup") {
      //   closeVideoPopupByEsc();
      // }
    }
  };

  // Add escape key listener once
  document.addEventListener("keydown", handleEscapeKey);

  if (window.innerWidth < 999) {
    // Object to store references to our elements and handlers
    const mobileMenu = {
      elements: {
        layerOpeners: null,
        menuDropdown: null,
      },
      handlers: {
        handleOpen: null,
        handleClose: null,
        handleCloseDrawer: null,
      },
      init() {
        this.cacheElements();
        this.setupHandlers();
        this.bindEvents();
      },
      cacheElements() {
        this.elements.layerOpeners =
          document.querySelectorAll(".menu-block-mobile");
      },
      setupHandlers() {
        // Use arrow functions to maintain 'this' context
        this.handlers.handleOpen = (e) => {
          const menuBlock = e.currentTarget.closest(".mobile-menu_block");
          const hiddenLayer = menuBlock.querySelector(".mobile-hidden-menu");
          hiddenLayer.classList.add("show");

          // Add close handler for this specific submenu
          const closeBtn = hiddenLayer.querySelector(".return_icon");
          const closeMenuDrawer = hiddenLayer.querySelector(
            ".close_mobile_menu--2"
          );
          closeBtn.addEventListener("click", this.handlers.handleClose);
          closeMenuDrawer.addEventListener(
            "click",
            this.handlers.handleCloseDrawer
          );
        };

        this.handlers.handleClose = (e) => {
          const hiddenLayer = e.target.closest(".mobile-hidden-menu");
          hiddenLayer.classList.remove("show");
          const closeMenuDrawer = hiddenLayer.querySelector(
            ".close_mobile_menu--2"
          );
          closeMenuDrawer.removeEventListener(
            "click",
            this.handlers.handleCloseDrawer
          );
        };
        this.handlers.handleCloseDrawer = (e) => {
          e.stopPropagation();
          toggleMenu();
          this.handlers.handleClose(e);
        };
      },
      bindEvents() {
        // Bind open handlers to each menu item
        this.elements.layerOpeners.forEach((opener) => {
          opener.addEventListener("click", this.handlers.handleOpen);
        });
      },
      cleanup() {
        // Cleanup event listeners when needed
        this.elements.layerOpeners.forEach((opener) => {
          opener.removeEventListener("click", this.handlers.handleOpen);
        });
      },
    };

    // Initialize the mobile menu
    mobileMenu.init();
  }

  window.openCartDrawer = openCartDrawer;
  window.closeCartDrawer = closeCartDrawer;
  window.activeComponent = activeComponent;

  window.openFilterDrawer = openFilterDrawer;
  window.closeFilterDrawer = closeFilterDrawer;

  window.closeSearch = closeSearch;
  window.showSearch = showSearch;

  window.toggleMenu = toggleMenu;
});
